import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.trends-library': {
    width: '100%',
    flexDirection: 'column',
    overflowX: 'hidden',
    padding: `${theme.space[4]} ${theme.space[8]} ${theme.space[4]} ${theme.space[6]}`,
  },
  '.trends-library': {
    '&__banner': {
      width: '100%',
      paddingBottom: '15px',
    },
    '&__header': {
      textAlign: 'center',
      margin: `${theme.space[5]} 0`,
    },
    '&__control-bar': {
      justifyContent: 'space-between',
      marginBottom: '2rem',
      alignItems: 'center',
      '&__launch-button': {
        marginRight: theme.space[3],
      },
      '&__info-icon': {
        alignSelf: 'center',
      },
      '&__right': {
        gap: theme.space[3],
        alignItems: 'end',
      },
    },
    '&__text--pink': {
      color: COLORS.SECONDARY300,
    },
  },
});
